import styles from './styles.module.scss';
import { ReactNode } from 'react';
import cn from 'classnames';

const Checkbox: React.FC<
  Partial<{
    onChanges: any;
    checked: boolean;
    children: ReactNode;
    className: string;
  }>
> = ({ onChanges, checked, children, className = '' }) => {
  return (
    <label
      className={cn(styles.filterLabel, className, {
        [styles.hasChildren]: !!children
      })}
    >
      <div className={styles.checkboxWrap}>
        <input
          className={styles.filterInput}
          type="checkbox"
          onChange={onChanges}
          checked={checked}
        />
        <span className={styles.filterCheckmark} />
      </div>
      {children && <div className={styles.checkBoxContent}>{children}</div>}
    </label>
  );
};

export default Checkbox;
